export const render = async data => {
  const { layers: paramLayers } = data;
  const internalLayers = buildLayers(paramLayers);
  const reducedString = reduceLayers(internalLayers);
  const rootPath = `style-final/${reducedString}`;
  const imageSlices = new Array(120).fill('').map((item, index) => {
    const indexString = index.toString().padStart(4, '0');
    return `https://d1j0ofdyze21yi.cloudfront.net/${rootPath}/${indexString}.jpg`;
  });

  return { images: imageSlices };
};

const buildLayers = ({ gender, body, face, hair, skin, top, bottom, shoes, hat }) => {
  const layers = {};
  const _body = [body, hair, skin];
  _body.push(hat ? [face, hat.toLowerCase().includes('cap') ? 'cap' : 'bucket'].join('-') : face);
  layers.avatar = { gender, body: _body.join('_') };
  const cloth = [];
  bottom && cloth.push({ gender, body, bottom });

  if (top) {
    const _top = [top];

    if (top === 'M_NK_DFADV_RUN_DVN_PNNCLE_TANK') {
      _top.push(face);
      _top.push(skin);
    }

    cloth.push({ gender, body, top: _top.join('_') });
  }

  cloth.length > 0 && (layers.cloth = cloth);
  shoes && (layers.shoes = { gender, shoes });
  hat && (layers.hat = { gender, body, hat });

  return layers;
};

const reduceLayers = layers => {
  const reduced = [];
  Object.keys(layers).forEach(layer => {
    const currentLayer = layers[layer];

    if (Array.isArray(currentLayer)) {
      currentLayer.forEach(subLayer => {
        reduced.push(Object.keys(subLayer).reduce((acc, key) => acc.concat('-', subLayer[key]), layer.toUpperCase()));
      });
    } else {
      reduced.push(
        Object.keys(currentLayer).reduce((acc, key) => acc.concat('-', currentLayer[key]), layer.toUpperCase())
      );
    }
  });

  return reduced.join('_');
};
